// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__S-FnP","description":"style_description__qXPZh","actions":"style_actions__0oNnz","actions_btn":"style_actions_btn__KWEI7"};